import ChaufferRides from "../../../assets/images/chauffer-rides.png";
import PersonalWebsite from "../../../assets/images/personal-website.png";
import VideoCall from "../../../assets/images/video-call.png";
import Editor from "../../../assets/images/editor.png";
import ProjectCard, { ProjectCardProps } from "./ProjectCard";
import NPM from "../../../assets/images/npm.png";

const WEB_PROJECTS: ProjectCardProps[] = [
  {
    name: "Personal Portfolio",
    description: `Portfolio Website developed using the React.js framework. This project showcases the technical prowess and creative talents of individuals in a visually stunning and interactive manner, leveraging the latest web development technologies and design principles.`,
    imageLink: PersonalWebsite,
    link: "/",
  },
  {
    name: "Video call",
    description:
      "A video call application which helps to connect with your peers seamlessly.",
    imageLink: VideoCall,
  },
  {
    name: "Collaborative Editor",
    description:
      "A real-time collaborative document editor that lets multiple users create and edit documentation together seamlessly.",
    imageLink: Editor,
    link: "https://main.d1b7q92kcagee5.amplifyapp.com/",
  },
  {
    name: "dg-utilities",
    description:
      "A utility npm package used for for functions to use in daily life",
    imageLink: NPM,
    link: "https://www.npmjs.com/package/dg-utilities",
  },
  {
    name: "Chauffer Rides",
    description:
      "Chauffeur Rides is a state-of-the-art Chauffeur Booking Platform developed using the React.js framework. This platform serves as a centralized hub for connecting users with professional chauffeurs, offering seamless booking, scheduling, and management of chauffeur services.",
    imageLink: ChaufferRides,
  },
];

const Project = () => {
  return (
    <section
      id="projects"
      className="mb-16 scroll-mt-16 md:mb-24 lg:mb-36 lg:scroll-mt-24"
      aria-label="Selected projects"
    >
      <div className="sticky top-0 z-20 -mx-6 mb-4 w-screen bg-slate-900/75 px-6 py-5 backdrop-blur md:-mx-12 md:px-12 lg:sr-only lg:relative lg:top-auto lg:mx-auto lg:w-full lg:px-0 lg:py-0 lg:opacity-0">
        <h2 className="text-sm font-bold uppercase tracking-widest text-slate-200 lg:sr-only">
          Web Projects
        </h2>
      </div>

      <h2 className="font-display mb-8 hidden bg-gradient-to-r from-fuchsia-300 to-indigo-300 bg-clip-text text-2xl font-bold tracking-tight text-transparent lg:block">
        Web Projects
      </h2>

      <div>
        <ul className="group/list">
          {WEB_PROJECTS.map((el) => (
            <ProjectCard {...el} key={el.name} />
          ))}
        </ul>
      </div>
    </section>
  );
};
export default Project;
